(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationJournal', ApplicationJournal);

    ApplicationJournal.$inject = ['$resource'];

    function ApplicationJournal ($resource) {
        var resourceUrl =  'api/application-journals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
